import {get} from "./axios";
import HikStreamVO from "@/components/player/HikStreamVO";


// 大屏展示用户绑定执法仪画面
export function listUserCameraVO() {
  return get('/hik-binding/list/UserCameraVO')
}
// 获取设备列表
export async function listDevice() {
  const res = await get("/hik-device/page/1/100");
  return res.data.map((row, index) => ({
    serialNO: row.serialNO,
    deviceIndexCode: row.deviceCode,
    cameraIndexCode: row.cameraCode,
    state: row.deviceStatus && row.cameraStatus ? '在线' : '离线',
    roleName: '空警',
    userNickname: `空警${index + 1}`,
    url: `/hik-device/getUrl/${row.cameraCode}/wss`
  }));
}

export async function getHikStreamVO(device) {
  const result = await get(device.url)
  console.log(['result', result])
  if (result.code === 'A00000') {
    if (result.rowCount > 0) {
      return new HikStreamVO({ key: device.serialNO, protocol: "wss", url: result.data[0] });
    }
  }
  throw new Error('执法仪画面播放加载失败，请确认设备是否正常注册到平台')
}



// WEBPACK FOOTER //
// ./src/api/hik.js